export default function ErrorFallback({ resetError }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-canvas to-canvas flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        <h1 className="text-2xl font-display font-bold text-ink-soft mb-3">
          Something went wrong
        </h1>
        <p className="font-body text-ink-soft mb-6">
          An unexpected error occurred. Please try again.
        </p>
        <button
          onClick={resetError}
          className="px-6 py-3 bg-sage-100 text-white font-body font-semibold rounded-xl shadow-sm hover:bg-sage-200 transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
